import React from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import { withCoreComponent, withGameActions, withUser } from 'core/hocs';
import { GameTags as GameTagsCore, FormattedTag } from 'core/components';
import { isEmptyOrNil } from 'core/helpers';
import { GameCard } from 'components/game-card/game-card';
import { GamesGridPreloader } from 'components/games-grid-preloader/games-grid-preloader';

import './game-tags-page-content.scss';

const GameTagsPageContentUI = ({
  tag, games, isInProgress, openGame, toggleFavoriteGame, isUserLoggedIn
}) => (
  <div className="game-tags-page-content">
    <div className="mt-4 mt-md-5 game-tags-page-content-wrapper">
      <FormattedTag
        id={`game-tags.title.${tag}`}
        className="game-tags-page-content-title d-block text-center mt-2 mb-2_5 mt-sm-3 mb-sm-3 mt-md-5 mb-md-5 "
      />

      {isInProgress || R.isNil(games)
        ? <GamesGridPreloader rows={3} />
        : (
          <div className="game-tags-page-content-wrapper-list">
            {!isEmptyOrNil(games) && games.map(game => (
              <GameCard
                key={`${game.gameId}-${game.producer}`}
                {...game}
                openGame={openGame}
                isUserLoggedIn={isUserLoggedIn}
                toggleFavoriteGame={toggleFavoriteGame}
              />
            ))}
          </div>
        )}
    </div>
  </div>
);

GameTagsPageContentUI.propTypes = {
  tag: PropTypes.string.isRequired,
  isInProgress: PropTypes.bool.isRequired,
  games: PropTypes.arrayOf(PropTypes.shape),
  openGame: PropTypes.func.isRequired,
  toggleFavoriteGame: PropTypes.func.isRequired,
  isUserLoggedIn: PropTypes.bool,
};

GameTagsPageContentUI.defaultProps = {
  games: null,
  isUserLoggedIn: false,
};

export const GameTagsPageContent = withCoreComponent(GameTagsCore, withGameActions(withUser(GameTagsPageContentUI)));
